<template>
	<div class="favorite-button item">
		<template v-if="!isLoading">
			<button v-if="!isFavorite" @click.prevent="setProfileFavorite()" class="button">
				<span class="icon fastic-star"></span>
				<span class="label">{{ localizer.get("PrivateArea.Common.Asset_ProfileFavorite_AddToFavorite") }}</span>
			</button>
			<button v-else @click.prevent="removeProfileFavorite()" class="button">
				<span class="icon fastic-star-full active"></span>
				<span class="label">{{ localizer.get("PrivateArea.Common.Asset_ProfileFavorite_RemoveToFavorite") }}</span>
			</button>
		</template>
		<span v-else class="loader" data-color="blue"></span>
	</div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

const props = defineProps<{
	itemIdMaster: string;
	itemType: string;
	isFavoritePage: boolean;
}>();

const emit = defineEmits<{
	updateData: [];
}>();

const store = useStore();
const localizer = Localizer;
const isLoading = ref(false);
const isFavorite = ref(false);
const validationErrors = ref<any[]>([]);
const routes = (window as any).App.routes;

onMounted(async () => {
	isLoading.value = true;
	isFavorite.value = (await Axios.post(routes.PrivateArea_GetProfileFavorite, { ItemIdMaster: props.itemIdMaster })).data;
	isLoading.value = false;
});

async function setProfileFavorite() {
	validationErrors.value = [];
	isLoading.value = true;

	try {
		await Axios.post(routes.PrivateArea_SetProfileFavorite, { ItemIdMaster: props.itemIdMaster, ItemType: props.itemType });
		isFavorite.value = true;

		store.dispatch("accountAreaToastStore/onAddToast", { message: localizer.get("PrivateArea.Common.Asset_ProfileFavorite_AddSuccess"), type: "Success" });

		GTagHelper.sendEvent("click", "render_favorite", "add");
	} catch (error) {
		if (error.response && error.response.status === 400) {
			validationErrors.value = FormHelper.getValidationErrors(error.response.data);
		}
		for (const validationError of validationErrors.value) {
			store.dispatch("accountAreaToastStore/onAddToast", { message: validationError.message, type: "Warning" });
		}
	}

	isLoading.value = false;
}

async function removeProfileFavorite() {
	validationErrors.value = [];
	isLoading.value = true;

	try {
		await Axios.post(routes.PrivateArea_RemoveProfileFavorite, { ItemIdMaster: props.itemIdMaster });

		store.dispatch("accountAreaToastStore/onAddToast", { message: localizer.get("PrivateArea.Common.Asset_ProfileFavorite_RemoveSuccess"), type: "Success" });

		GTagHelper.sendEvent("click", "render_favorite", "remove");

		if (props.isFavoritePage) {
			emit("updateData");
		}
		isFavorite.value = false;
	} catch (error) {
		if (error.response && error.response.status === 400) {
			validationErrors.value = FormHelper.getValidationErrors(error.response.data);
		}
		for (const validationError of validationErrors.value) {
			store.dispatch("accountAreaToastStore/onAddToast", { message: validationError.message, type: "Warning" });
		}
	}

	isLoading.value = false;
}
</script>
